import * as React from "react";
import './widget.css'

const Quicklinks: React.FC = () => {
  return (    
      <section className="widget">
        <h2>Quick Links</h2>
        <ul className="widget-content">
          <li>
            <a href="http://www.clearstream.com/" target="_blank" rel="noreferrer">
              Clearstream website
            </a>
          </li>
        </ul>
      </section>    
  );
};

export default Quicklinks;
